import { render, staticRenderFns } from "./ServicesMenu.vue?vue&type=template&id=8bc86b88"
import script from "./ServicesMenu.vue?vue&type=script&lang=js"
export * from "./ServicesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports